// eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-denylist,id-match
export const Type = Function;

export function isType(v: any): v is Type<any> {
	return typeof v === 'function';
}

export type Type<T> = new (...args: any[]) => T;
